module.exports = __webpack_public_path__ + "img/logo_transparente.a819b140.png";